import {
 
  Fonts
} from "react-bootstrap-icons";

export enum DrawAction {
  Select = "select",
  Rectangle = "rectangle",
  Circle = "circle",
  Scribble = "freedraw",
  Arrow = "arrow",
  Text = "text"
}

export const PAINT_OPTIONS = [
  { id: DrawAction.Text, label: "Text", icon: <Fonts size={35} width={25}/> },
];
